/* istanbul ignore file */
import { makeStyles } from '@mui/styles';

import Skeleton from '@classify/react-core-components/Skeleton';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, palette }) => ({
    item: {
      display: 'flex',
      padding: spacing(2, 1),
      overflow: 'hidden',
      '&:not(:last-child)': {
        borderBottom: `1px solid ${palette.layout.line.divider}`,
      },
    },

    text: {
      marginLeft: spacing(2),
    },
  })
);

export default function LoadingSkeleton() {
  const classes = useStyles();

  return (
    <div>
      <Skeleton
        width="100px"
        height="18px"
        variant="rectangular"
        sx={{ marginBottom: '24px', display: 'block' }}
      />
      <div className={classes.item}>
        <div>
          <Skeleton variant="circular" width="40px" height="40px" />
        </div>
        <div className={classes.text}>
          <Skeleton
            width="120px"
            height="18px"
            variant="rectangular"
            sx={{ marginBottom: '8px', display: 'block' }}
          />
          <Skeleton width="240px" height="18px" variant="rectangular" sx={{ display: 'block' }} />
        </div>
      </div>

      <div className={classes.item}>
        <div>
          <Skeleton variant="image" width="40px" borderRadius="circle" />
        </div>
        <div className={classes.text}>
          <Skeleton width="100px" height="18px" sx={{ marginBottom: '8px', display: 'block' }} />
          <Skeleton width="210px" height="18px" sx={{ display: 'block' }} />
        </div>
      </div>

      <div className={classes.item}>
        <div>
          <Skeleton variant="image" width="40px" borderRadius="circle" />
        </div>
        <div className={classes.text}>
          <Skeleton width="80px" height="18px" sx={{ marginBottom: '8px', display: 'block' }} />
          <Skeleton width="260px" height="18px" sx={{ display: 'block' }} />
        </div>
      </div>
    </div>
  );
}
